// AUTO-GENERATED by tools/codegen (pnpm gen). Do not edit. Source: apps/client/src/net/handlers/*.ts
import * as m0 from './handlers/chat';
import * as m1 from './handlers/core';
import * as m2 from './handlers/decor';
import * as m3 from './handlers/digging';
import * as m4 from './handlers/fishing';
import * as m5 from './handlers/items';
import * as m6 from './handlers/mail';
import * as m7 from './handlers/museum';
import * as m8 from './handlers/nature';
import * as m9 from './handlers/news';
import * as m10 from './handlers/villagers';
export const netHandlerModules = [m0, m1, m2, m3, m4, m5, m6, m7, m8, m9, m10] as const;
